import { render } from "./MultiFactorAuthCode.vue?vue&type=template&id=68a40a8a"
import script from "./MultiFactorAuthCode.vue?vue&type=script&lang=js"
export * from "./MultiFactorAuthCode.vue?vue&type=script&lang=js"

import "./MultiFactorAuthCode.vue?vue&type=style&index=0&id=68a40a8a&lang=css"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__